module.exports = __webpack_public_path__ + "d28c6d3da36855aeb600d0081a724665.webp";